import React, { useState, useEffect } from 'react';

// --- داده‌های صفحه اصلی ---
const homeData = {
    "hero": {
        "mainTitle": "تحلیل و طراحی سازه در مهندسی عمران",
        "buttonText": "مشاهده همه‌ی دوره‌ها",
        "slideshowImages": [
            "https://daneshesaze.com/Album/Album01.jpg",
            "https://daneshesaze.com/Album/Album02.jpg",
            "https://daneshesaze.com/Album/Album03.jpg",
            "https://daneshesaze.com/Album/Album04.jpg",
            "https://daneshesaze.com/Album/Album05.jpg",
            "https://daneshesaze.com/Album/Album06.jpg",
            "https://daneshesaze.com/Album/Album07.jpg",
            "https://daneshesaze.com/Album/Album08.jpg",
            "https://daneshesaze.com/Album/Album09.jpg",
            "https://daneshesaze.com/Album/Album10.jpg",
            "https://daneshesaze.com/Album/Album11.jpg",
            "https://daneshesaze.com/Album/Album12.jpg",
            "https://daneshesaze.com/Album/Album13.jpg",
            "https://daneshesaze.com/Album/Album14.jpg",
            "https://daneshesaze.com/Album/Album015.jpg",
            "https://daneshesaze.com/Album/Album016.jpg",
            "https://daneshesaze.com/Album/Album024.jpg"
        ]
    },
    "socials": [
        {
            "name": "یوتیوب",
            "link": "https://www.youtube.com/@daneshesaze",
            "icon": "youtube",
            "colorClass": "text-red-600 hover:text-red-600",
            "colorBg": "bg-red-50",
            "viewBox": "0 0 24 24",
            "path": "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.376.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.376-.505a3.017 3.017 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
        },
        {
            "name": "آپارات",
            "link": "https://www.aparat.com/daneshesaze",
            "icon": "aparat",
            "colorClass": "text-orange-500 hover:text-orange-500",
            "colorBg": "bg-orange-50",
            "viewBox": "0 0 24 24",
            "path": "M4.92,2.37a3.1,3.1,0,0,0-2.4,4.84L6.94,12,2.52,16.79a3.1,3.1,0,0,0,2.4,4.84,3.22,3.22,0,0,0,1.5-.37L20.66,13.1a3.1,3.1,0,0,0,0-2.2L6.42,2.74A3.22,3.22,0,0,0,4.92,2.37Z"
        },
        {
            "name": "تلگرام",
            "link": "https://t.me/daneshesaze0com",
            "icon": "telegram",
            "colorClass": "text-blue-500 hover:text-blue-500",
            "colorBg": "bg-blue-50",
            "viewBox": "0 0 24 24",
            "path": "M21.883 12l-1.442 7.712c-.22 1.187-1.15 2.122-2.36 2.122-.32 0-.63-.06-.92-.17l-4.7-1.75-2.33 2.22c-.68.68-1.57.97-2.48.97-.2 0-.4-.02-.6-.05-.96-.18-1.7-1-1.7-1.98v-3.7L1.13 13.13c-1.33-.52-1.33-2.23 0-2.76l21-8.05c1.13-.43 2.2.46 1.9 1.63l-3.15 14.05zM5.3 12.06l11.36-4.3-8.8 8.44-1.3 4.14 2.3-2.2-8.16-3.7z"
        },
        {
            "name": "اینستاگرام",
            "link": "https://www.instagram.com/daneshe_saze?igsh=MWI3Njd2YXgyMGR6aQ%3D%3D&utm_source=qr",
            "icon": "instagram",
            "colorClass": "text-pink-600 hover:text-pink-600",
            "colorBg": "bg-pink-50",
            "viewBox": "0 0 24 24",
            "path": "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849s-.012 3.584-.07 4.849c-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07s-3.584-.012-4.849-.07c-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849s.012-3.584.07-4.849C2.43 3.854 3.947 2.309 7.151 2.232c1.265-.058 1.644-.07 4.849-.07zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12s.014 3.667.072 4.947c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24s3.667-.014 4.947-.072c4.358-.2 6.78-2.618 6.98-6.98.058-1.28.072-1.687.072-4.947s-.014-3.667-.072-4.947c-.2-4.357-2.618-6.78-6.98-6.98C15.667.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 1 0 2.88 1.44 1.44 0 0 1 0-2.88z"
        }
    ],
    "software": [
        {
            "title": "دوره پیشرفته ETABS و SAFE سازه بتنی",
            "img": "https://daneshesaze.com/logoIcon/EtabsConcrete.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=ufQJyQ9sgAI&list=PL3sn7nN8lT5w3AR1IItXO_JWE8kt1ZAQM"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756139"
                }
            ]
        },
        {
            "title": "دوره جامع اپن سیس",
            "img": "https://daneshesaze.com/logoIcon/OpenSees.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=nOUUTvlW4TI&list=PL3sn7nN8lT5yBN2ncQR4t_j3qjiKq_2RX"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756012"
                }
            ]
        },
        {
            "title": "آموزش ایتبس سازه فولادی",
            "img": "https://daneshesaze.com/logoIcon/EtabsSteel.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=pf6VATNwfv8&list=PL3sn7nN8lT5wbPvHqfGEkYX0poVuUrwMe"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756139"
                }
            ]
        }
    ],
    "academic": [
        {
            "title": "طراحی سازه های فولادی 1",
            "img": "https://daneshesaze.com/logoIcon/SteelDesign.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=_n0PhTU6nHs&list=PL3sn7nN8lT5xo3v3zVdB_mTbrKl9BdcAK"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/11704702"
                }
            ]
        },
        {
            "title": "تحلیل سازه 1",
            "img": "https://daneshesaze.com/logoIcon/Structural-Analysis1.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=CUgvX51As4k&list=PL3sn7nN8lT5y28LcgLg6pDX4EGLV748NX"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/7597553"
                }
            ]
        },
        {
            "title": "تحلیل سازه ها 2",
            "img": "https://daneshesaze.com/logoIcon/Structural-Analysis2.jpg.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=R2e7OSqn6Eg&list=PL3sn7nN8lT5xeYCJR8THkjoJNwaQ3YqxQ"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/v/hnn4o0r?playlist=10169627"
                }
            ]
        },
        {
            "title": "مبانی بهسازی",
            "img": "https://daneshesaze.com/logoIcon/retrofit.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=NHyxFbaKdjU&list=PL3sn7nN8lT5zN76qfRKe0nDV1cQDJq9Br"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756108"
                }
            ]
        },
        {
            "title": "تحلیل غیر خطی سازه‌ها",
            "img": "https://daneshesaze.com/logoIcon/nonlinear.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=8ISg6o06M58&list=PL3sn7nN8lT5wkXah72y1OPruAXZEdv5LD"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756374"
                }
            ]
        },
        {
            "title": "سازه‌های بتن آرمه 1",
            "img": "https://daneshesaze.com/logoIcon/ConcreteDesign.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=dDenFn7-pfY&list=PL3sn7nN8lT5wNoW41lpugO9sUyZ_f81JY"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5936566"
                }
            ]
        },
        {
            "title": "سازه‌های بتن آرمه 2",
            "img": "https://daneshesaze.com/logoIcon/ConcreteDesign2.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=ekH9sGZXXVQ&list=PL3sn7nN8lT5wOi-aIgaiFyTTyadXjI4vP"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756189"
                }
            ]
        },
        {
            "title": "طراحی لرزه ای سازه ها",
            "img": "https://daneshesaze.com/logoIcon/seismic-general.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=WTUXkGyoOx4&list=PL3sn7nN8lT5xhODVktBNLzxvmxZ5r1BUg"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/5756021"
                }
            ]
        },
        {
            "title": "طراحی لرزه ای سازه های بتنی",
            "img": "https://daneshesaze.com/logoIcon/SeismicConcrete.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=lQtF-WinvMw&list=PL3sn7nN8lT5xXj4Kxg9gbT3slhI9ZeHiU"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/v/v798u61?playlist=6772127"
                }
            ]
        },
        {
            "title": "آموزش دینامیک",
            "img": "https://daneshesaze.com/logoIcon/Dynamics.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=uE45ihB9SpQ&list=PL3sn7nN8lT5z9E6vXZm90rjUHjUV6MCkX"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/21810680"
                }
            ]
        },
        {
            "title": "از هر دری و سخنی (کلی)",
            "img": "https://daneshesaze.com/logoIcon/general.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=-c81N67xhy0&list=PL3sn7nN8lT5y2X4MqzEOAkDqu5ghlrP0V"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/playlist/6553664"
                }
            ]
        },
        {
            "title": "سوالات کنکور کارشناسی ارشد",
            "img": "https://daneshesaze.com/logoIcon/konkur.jpg",
            "links": [
                {
                    "type": "youtube",
                    "url": "https://www.youtube.com/watch?v=gqsIIzY1qmc&list=PL3sn7nN8lT5wYM4obJIC28pIH9L5NoifZ"
                },
                {
                    "type": "aparat",
                    "url": "https://www.aparat.com/v/r914mle"
                }
            ]
        }
    ]
};

// --- کارت‌های چرخشی (Flip Card) مخصوص صفحه اصلی ---
const FlipCard = ({ item }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    // Dynamic Alt Text for SEO
    const altText = `آموزش درس ${item.title} دانشگاهی که برای دانشجویان رایگان است`;

    return (
        <div 
            className={`flip-card group ${isFlipped ? 'flipped' : ''}`} 
            onClick={() => setIsFlipped(!isFlipped)}
        >
            <div className="flip-card-inner">
                {/* Front */}
                <div className="flip-card-front flex flex-col">
                    <img src={item.img} alt={altText} className="w-full h-40 object-cover" onError={(e) => e.target.src = 'https://placehold.co/400x300/e2e8f0/64748b?text=Course'} />
                    <div className="p-4 flex-grow text-right">
                        <h3 className="text-lg font-bold mb-2 group-hover:text-blue-600 transition-colors">{item.title}</h3>
                        <span className="text-lg font-bold text-green-600">رایگان</span>
                    </div>
                </div>
                {/* Back */}
                <div className="flip-card-back p-4">
                    <p className="text-slate-700 font-bold mb-4">مشاهده در:</p>
                    {item.links.map((link, idx) => {
                        const isYoutube = link.type === 'youtube';
                        return (
                            <a 
                                key={idx}
                                href={link.url} 
                                target="_blank" 
                                rel="noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                className={`platform-btn ${isYoutube ? 'text-red-600' : 'text-pink-600'} border-none`}
                            >
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                    {isYoutube ? (
                                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.376.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.376-.505a3.017 3.017 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
                                    ) : (
                                        <path d="M4.92,2.37a3.1,3.1,0,0,0-2.4,4.84L6.94,12,2.52,16.79a3.1,3.1,0,0,0,2.4,4.84,3.22,3.22,0,0,0,1.5-.37L20.66,13.1a3.1,3.1,0,0,0,0-2.2L6.42,2.74A3.22,3.22,0,0,0,4.92,2.37Z"></path>
                                    )}
                                </svg>
                                {isYoutube ? 'یوتیوب' : 'آپارات'}
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default function MainPage() {
    const [currentSlide, setCurrentSlide] = useState(0);

    // اسلایدشو
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % homeData.hero.slideshowImages.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="container mx-auto px-4 py-12 animate-fadeIn">
            {/* Hero Section */}
            <section className="relative w-full h-[500px] md:h-[600px] rounded-[53px] overflow-hidden mb-16 group glass-card">
                 <div className="absolute inset-0 w-full h-full">
                     {homeData.hero.slideshowImages.map((img, idx) => (
                         <img 
                            key={idx}
                            alt="دانش سازه- دکتر حر خسروی استاد دانشگاه نوشیروانی بابل است." 
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${idx === currentSlide ? 'opacity-100' : 'opacity-0'}`}
                            src={img}
                         />
                     ))}
                     <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-blue-800/70 to-blue-900/40 mix-blend-multiply"></div>
                </div>
                <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
                    <h1 className="text-4xl md:text-6xl font-extrabold mb-8 text-white drop-shadow-lg leading-tight tracking-tight">
                        {homeData.hero.mainTitle}
                    </h1>
                    <button 
                        onClick={() => {
                            const el = document.getElementById('course-section-software');
                            if(el) el.scrollIntoView({ behavior: 'smooth'});
                        }}
                        className="bg-[#f0f0f3] text-blue-800 font-bold px-10 py-4 rounded-full text-lg md:text-xl transition-all transform shadow-[5px_5px_10px_#1e3a8a,-5px_-5px_10px_#ffffff20] hover:shadow-[inset_5px_5px_10px_#bebebe,inset_-5px_-5px_10px_#ffffff]"
                    >
                        {homeData.hero.buttonText}
                    </button>
                </div>
            </section>

            {/* Socials */}
            <section className="mb-12">
                <h2 className="text-3xl font-bold text-center mb-8 text-slate-700">ما را در شبکه‌های اجتماعی دنبال کنید</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
                    {homeData.socials.map((s, idx) => (
                        <a 
                            key={idx}
                            href={s.link}
                            target="_blank"
                            rel="noreferrer"
                            className={`glass-card rounded-[53px] p-4 md:p-6 flex flex-col items-center justify-center transition-all ${s.colorClass} group`}
                        >
                            <svg className={`w-12 h-12 md:w-16 md:h-16 mb-4 ${s.colorClass} group-hover:scale-110 transition-transform`} fill="currentColor" viewBox={s.viewBox}>
                                <path d={s.path}></path>
                            </svg>
                            <span className="text-md md:text-lg font-semibold text-slate-700">{s.name}</span>
                        </a>
                    ))}
                </div>
            </section>

            {/* Software Courses */}
            <section id="course-section-software" className="mb-16">
                <h2 className="text-3xl font-bold text-center mb-8 text-slate-700">دوره‌های نرم‌افزاری</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {homeData.software.map((course, idx) => (
                        <FlipCard key={idx} item={course} />
                    ))}
                </div>
            </section>

            {/* Academic Courses */}
             <section id="course-section-academic" className="mb-16">
                <h2 className="text-3xl font-bold text-center mb-8 text-slate-700">دوره‌های دانشگاهی و مفهومی</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {homeData.academic.map((course, idx) => (
                        <FlipCard key={idx} item={course} />
                    ))}
                </div>
            </section>
        </div>
    );
}